<div class="section">
  <div class="section__header">
    <h2 class="section__header-text">Hours of Operation
    <mat-icon (click)="openEditHoursDialog()"
      *ngIf="editModeSet && !isRegionalManager" class="edit-icon">edit</mat-icon>
    </h2>
  </div>
  <div class="section__body">
    <div class="data-block" *ngIf="formatHoursTags().length > 0">
      <div class="data-block__item">
        <div class="data-block__value">
          {{ formatHoursTags() }}
        </div>
      </div>
    </div>

    <ng-container *ngIf="formatHoursTags().length === 0">
      <table *ngIf="business.hours.length > 0; else placeholder" class="data-block">
        <thead>
          <tr>
            <th class="data-block__label">From Date</th>
            <th class="data-block__label">To Date</th>
            <th class="data-block__label">From Day</th>
            <th class="data-block__label">To Day</th>
            <th class="data-block__label">From Time</th>
            <th class="data-block__label">To Time</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let hour of business.hours" class="data-block__item">
            <td class="data-block__value">{{ hour.fromMmDd }}</td>
            <td class="data-block__value">{{ hour.toMmDd }}</td>
            <td class="data-block__value">{{ hour.fromWeekDay }}</td>
            <td class="data-block__value">{{ hour.toWeekDay }}</td>
            <td class="data-block__value">{{ formatHour(hour.fromTime) }}</td>
            <td class="data-block__value">{{ formatHour(hour.toTime) }}</td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </div>
  <div class="section__footer" *ngIf="!isClosedHolidaysNullEmptyOrUndefined()">
    <div class="hours__disclaimers"><em>Exceptions: {{ business.hoursExceptions }}</em></div>
  </div>
</div>
<ng-template #placeholder>
  <div class="detail-page__placeholder">
    <mat-icon class="detail-page__placeholder-icon">info</mat-icon>
    <div class="detail-page__placeholder-message">Unknown</div>
  </div>
</ng-template>
